import ReactDOM from 'react-dom/client'
import L from 'leaflet'
import { createControlComponent } from '@react-leaflet/core'
import Button from '@material-ui/core/Button'
import BorderOuterIcon from '@material-ui/icons/BorderOuter'

const node = L.DomUtil.create('div')

L.Control.FitBoundsToData = L.Control.extend({
  options: {
    position: 'bottomleft',
  },

  onAdd: (map: L.Map) => {
    const handleClick = () => {
      const latLngs: any[] = []

      map.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          const latLng = layer.getLatLng()
          if (latLng) latLngs.push(latLng)
        }
      })

      if (latLngs.length !== 0) map.fitBounds(latLngs, { animate: false })
      else {
        const iranBounds: L.LatLngBoundsExpression = [
          [25, 44],
          [40, 63],
        ]
        map.fitBounds(iranBounds, { animate: false })
      }
    }

    const element = ReactDOM.createRoot(node)
    element.render(
      <Button
        onClick={handleClick}
        style={{
          background: '#fff',
          width: 30,
          minWidth: 'unset',
          height: 30,
          padding: 15,
        }}
        className="leaflet-control-layers"
      >
        <BorderOuterIcon />
      </Button>,
    )

    return node
  },

  onRemove: () => {},
})

export const FitBoundsToData = createControlComponent(
  (props) => new L.Control.FitBoundsToData(props),
)
